module.exports = __webpack_public_path__ + "static/victoria-memorial-penny-farthing-3766cbbcb61a99932297212720b1a0c3.jpg";